import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da20getv7gurs51ef2eg";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // anti-spam honeypot check (must be empty for a real user)
    const honeypot = (fd.get("website_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus("success");
      return;
    }

    const payload = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key === "website_alt") return;
      if (typeof value === "string" && value.trim() !== "") {
        payload.append(key, value);
      }
    });

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let code = "";
      let message = "";
      try {
        const parsed = JSON.parse(responseText);
        code = parsed?.code || "";
        message = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      } catch {
        code = "";
      }
      if (res.ok && code === "OK") {
        setStatus("success");
        setFormError("");
        setEmail("");
      } else {
        setStatus("error");
        setFormError(message && message.toLowerCase().includes("spam") ? "提交失败，请稍后再试。" : message || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="mx-auto max-w-7xl px-4 pb-16 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-2xl bg-primary-800 px-6 py-12 md:px-12 md:py-16">
        <i className="ri-heart-3-fill absolute -right-8 -top-8 text-[10rem] text-primary-700" aria-hidden="true"></i>
        <i className="ri-sparkling-2-fill absolute bottom-6 right-24 text-4xl text-secondary-400" aria-hidden="true"></i>
        <div className="relative max-w-2xl">
          <p className="text-sm font-semibold text-background-200">订阅更新提醒</p>
          <h2 className="mt-1 font-heading text-2xl text-background-50 md:text-3xl">
            订阅后，新番更新不错过
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-100">
            留下你的邮箱，每周为你整理最值得追的高甜、萌系与少女漫画，第一时间送达更新提醒。
          </p>

          {status === "success" ? (
            <div className="mt-6 flex items-center gap-3 rounded-lg bg-background-50/15 px-5 py-4 text-background-50">
              <i className="ri-checkbox-circle-fill text-2xl text-secondary-400" aria-hidden="true"></i>
              <p className="text-sm">订阅成功啦！新的漫画更新会第一时间送到你的邮箱。</p>
            </div>
          ) : (
            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="mt-6"
              noValidate
            >
              <label className="sr-only" htmlFor="nl-email">邮箱地址</label>
              <div className="flex flex-col gap-3 sm:flex-row">
                <input
                  id="nl-email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入常用邮箱，如 you@example.com"
                  className="w-full rounded-md bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none ring-primary-400 focus:ring-2"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
                >
                  立即订阅
                </button>
              </div>
              <div className="hp-guard" aria-hidden="true">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
              </div>
              {status === "error" && formError && (
                <p className="mt-3 text-sm text-background-100">
                  <i className="ri-error-warning-line mr-1" aria-hidden="true"></i>
                  {formError}
                </p>
              )}
            </form>
          )}
          <p className="mt-4 text-xs text-background-200">
            <i className="ri-shield-check-line mr-1" aria-hidden="true"></i>
            我们尊重你的隐私，可随时取消订阅。
          </p>
        </div>
      </div>
    </section>
  );
}